import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-diseases.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetDiseasesDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metDiseasesEntity = useAppSelector(state => state.metDiseases.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metDiseasesDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metDiseases.detail.title">MetDiseases</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metDiseasesEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metDiseases.code">Code</Translate>
            </span>
          </dt>
          <dd>{metDiseasesEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metDiseases.name">Name</Translate>
            </span>
          </dt>
          <dd>{metDiseasesEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metDiseases.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metDiseasesEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metDiseases.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metDiseasesEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metDiseases.status">Status</Translate>
            </span>
          </dt>
          <dd>{metDiseasesEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-diseases" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-diseases/${metDiseasesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetDiseasesDetail;
